import * as theme from '../../theme';
import Heading from '../../components/Heading';
import { useNavigate } from "react-router";
import FocusScansList from '../../components/FocusScansList';

export default function FocusScans() {
  const navigate = useNavigate();

  function navigateBack() {
    navigate(`/dashboard`);
  }

  return (
    <div style={{ ...theme.Container.flexColumn.flexColumnContainer, ...theme.Container.center800 }}>
      <div style={theme.Container.flexColumn}>
        <Heading
          title={`Focus Scans`}
          onClick={() => navigateBack()}
        />
        <div style={{ ...theme.SubText2, paddingLeft: 10, paddingRight: 10 }}>
          Focus Scans are additional scans that we perform in addition to the Root Cause, Supplement, and Emotion scans. You will receive a separate report for any Focus Scans selected.
        </div>
      </div>
      <div style={theme.Container.fullMax}>
        <div style={theme.Container.flexOne}>
          <FocusScansList />
        </div>
      </div>
    </div>
  );
}